import React from "react";
import Modal from "react-bootstrap/Modal";
import AdminCustomerEdit from "./AdminCustomerEdit";

const AdminCustomerModal = ({
  show,
  onHide,
  customer,
  onCreated,
  onUpdated,
}) => {
  if (!customer) return null;

  const isNew = !customer.userId;

  const title = isNew
    ? "Nouveau client"
    : `${customer.userName || ""} ${customer.userFirstname || ""}${customer.userCompName?.trim()
      ? " / " + customer.userCompName
      : ""
    }`;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      keyboard
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <AdminCustomerEdit
          customer={customer}
          onCreated={onCreated}
          onUpdated={onUpdated}
        />
      </Modal.Body>
    </Modal>
  );
};

export default AdminCustomerModal;